export default {
    name: 'Tên',
    tel: 'Điện thoại',
    save: 'Tiết kiệm',
    confirm: 'Xác nhận',
    cancel: 'Hủy bỏ',
    delete: 'Xóa bỏ',
    complete: 'Thực hiện',
    loading: 'Đang tải...',
    telEmpty: 'Vui lòng điền vào điện thoại',
    nameEmpty: 'Xin vui lòng điền tên của bạn',
    nameInvalid: 'Vui lòng nhập tên chính xác',
    confirmDelete: 'Bạn chắc chắn bạn muốn xóa nó',
    telInvalid: 'Xin vui lòng nhập một số điện thoại hợp lệ',
    vanCalendar: {
        end: 'Kết thúc',
        start: 'Khởi đầu',
        title: 'Ngày chọn',
        confirm: 'Mục đích',
        startEnd: 'Khởi đầu / Kết thúc',
        weekdays: ['Ngày', 'Một', 'Hai', 'Ba', 'Bốn', 'Năm', 'Sáu'],
        // monthTitle: (year: number, month: number) => `${year} / ${month}`,
        // rangePrompt: (maxRange: number) => `Chọn không quá ${maxRange} ngày`,
    },
    vanCascader: {
        select: 'Xin vui lòng chọn',
    },
    vanContactCard: {
        addText: 'Thêm liên hệ',
    },
    vanContactList: {
        addText: 'Địa chỉ liên lạc mới',
    },
    vanPagination: {
        prev: 'Trang trước',
        next: 'Trang tiếp theo',
    },
    vanPullRefresh: {
        pulling: 'Kéo xuống để làm mới...',
        loosing: 'Phát hành để làm mới...',
    },
    vanSubmitBar: {
        label: 'Toàn bộ：',
    },
    vanCoupon: {
        unlimited: 'Không có ngưỡng sử dụng',
        // discount: (discount: number) => `Giảm giá ${discount * 10}%`,
        // condition: (condition: number) => `Ít nhất ${condition}`,
    },
    vanCouponCell: {
        title: 'Phiếu mua hàng',
        tips: 'Không có sẵn',
        // count: (count: number) => `${count} ảnh có sẵn`,
    },
    vanCouponList: {
        empty: 'Không có phiếu giảm giá',
        exchange: 'Đổi',
        close: 'Không có phiếu giảm giá',
        enable: 'Có sẵn',
        disabled: 'không có sẵn',
        placeholder: 'Vui lòng nhập mã phiếu giảm giá',
    },
    vanAddressEdit: {
        area: 'khu vực',
        postal: 'Mã bưu điện',
        areaEmpty: 'vui lòng chọn khu vực',
        addressEmpty: 'Vui lòng điền vào địa chỉ chi tiết',
        postalEmpty: 'Định dạng mã bưu chính không chính xác',
        defaultAddress: 'Đặt làm địa chỉ giao hàng mặc định',
        telPlaceholder: 'Số điện thoại di động của người nhận hàng',
        namePlaceholder: 'Tên người nhận hàng',
        areaPlaceholder: 'Chọn tỉnh / thành phố / huyện',
    },
    vanAddressEditDetail: {
        label: 'Địa chỉ',
        placeholder: 'Số nhà mặt phố, số phòng tầng và các thông tin khác',
    },
    vanAddressList: {
        add: 'Thêm địa chỉ',
    }
};